import isObject from './isObject';

type UnknownObject = Record<string, unknown>;

/**
 * @see https://stackoverflow.com/a/5878101
 */
export default function isPlainObject<
  T extends Record<string, unknown> = UnknownObject,
>(argument: unknown): argument is T {
  if (isObject(argument)) {
    if (typeof Object.getPrototypeOf === 'function') {
      const proto: unknown = Object.getPrototypeOf(argument);
      if (typeof proto === 'object') {
        // Case: Object.create(null);
        if (proto === null)
          return true;
        if (!(proto.constructor === Object || proto === Object.prototype)) {
          return false;
        }
      }
    }
    return Object.prototype.toString.call(argument) === '[object Object]';
  }
  return false;
}
